import * as ActionTypes from "constants/ActionTypes";
import { combineReducers } from "redux";

function textTrackCaptionSettingsVisible(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_TEXT_TRACK_CAPTION_SETTINGS_VISIBILITY:
      return action.visible;
    case ActionTypes.SET_ROUTE_DATA:
      return false;
    default:
      return state;
  }
}

function textTrackLanguage(state = "", action) {
  switch (action.type) {
    case ActionTypes.SET_TEXT_TRACK_LANGUAGE:
      return action.language;
    default:
      return state;
  }
}

function showCaptionsSelectionMenu(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_CAPTIONS_SELECTION_MENU_VISIBILITY:
      return action.visible;
    case ActionTypes.SET_TEXT_TRACK_LANGUAGE:
      return false;
    case ActionTypes.SET_TEXT_TRACK_CAPTION_SETTINGS_VISIBILITY:
      return false;
    case ActionTypes.SET_ROUTE_DATA:
      return false;
    default:
      return state;
  }
}

export default combineReducers({
  showCaptionsSelectionMenu,
  textTrackCaptionSettingsVisible,
  textTrackLanguage,
});
